<script>
  import { ShopBoxApiApp } from "@shopboxai/shopbox-api-app";
  import { currentUser, currentClientWebsite, currentClient } from "../stores";
</script>

<ShopBoxApiApp user={$currentUser} client={$currentClient} website={$currentClientWebsite} />
